<template>
  <modal 
    ref="notificatorModal" 
    height="auto" 
    :scrollable="true" 
    :resizable="true" 
    :adaptive="true" 
    width="1366px"
    name="snapshot-modal" 
    @before-open="beforeOpen">
      <img v-lazy='imageHost + "/" + check_id + ".png"' />
  </modal>
</template>
<script>
import API from "../api"

export default {
  name: 'snapshot-modal',
  data() {
    return {
      type: false,
      check_id: false,
    }
  },
  methods: {
    beforeOpen(event) {
      var $that = this;
      if(_.isUndefined(event.params) == false && event.params.check_id) {
        $that.check_id = event.params.check_id;
      }
    },
  },
  created() {}
}
</script>

<style lang="scss">
.v--modal-overlay[data-modal="snapshot-modal"] {
  .v--modal-box.v--modal {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SnapshotModal.vue